import type { ApolloClient } from '@apollo/client';
import type { QueryValidateCartItemsStockArgs } from '../../codegen/types';
import { ValidateCartItemsStockDocument } from '../../graphqlDocument/cart/validateCartItemsStock.generated';
import type { useNRBASession } from '../../hooks';
import { getBasketPageLink } from '../../utils/cartUtils';
import { newRelicAvailabilityChecker } from '../../utils/newrelic';
import { setItem } from '../../utils/storage';
import { createAnchorTagHref } from '../../utils/transformers';

interface ValidateCartItemsStockOptions {
  onSuccess?: () => void;
  apolloClient: ApolloClient<object>;
  input: QueryValidateCartItemsStockArgs['input'];
  locale: string;
  nrbaContextHeader: ReturnType<typeof useNRBASession>;
}

export async function validateCartItemsStock({
  onSuccess,
  apolloClient,
  input,
  nrbaContextHeader,
}: ValidateCartItemsStockOptions) {
  try {
    const response = await apolloClient.query({
      ...nrbaContextHeader,
      query: ValidateCartItemsStockDocument,
      variables: {
        input,
      },
    });
    if (response.data.validateCartItemsStock.success) {
      onSuccess?.();
    } else {
      setItem('VALIDATE_UPDATE_CART', true, true, 'localStorage');
      window.location.href = createAnchorTagHref({ locale: input.locale, path: getBasketPageLink(input.locale) });
    }
  } catch (error) {
    console.error('Error validating cart items stock:', error);
    newRelicAvailabilityChecker(() => {
      window.newrelic.noticeError(new Error(`Error validating cart items stock: ${error}`));
    });
    window.location.href = createAnchorTagHref({ locale: input.locale, path: '/checkout/payment/error' });
  }
}
